export default {"src":"/_next/static/media/businessDeletePosts.539f4916.svg","height":30,"width":39,"blurWidth":0,"blurHeight":0};